import { API_AUTH } from "./common";

const THUCHIHOPDONGApi = {
  list: ({
    tenKH,
    loaiKH,
    tinhtrangKH,
    trangthaiKH,
    nguonKH,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `quanlythuchi/thu-chi-hop-dong?tenKH=${tenKH}&loaiKH=${loaiKH}&tinhtrangKH=${tinhtrangKH}&trangthaiKH=${trangthaiKH}&nguonKH=${nguonKH}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),

  checkDaDoc: (thuchiId, isDaDoc) =>
    API_AUTH.post(
      `quan-ly-thu-chi/da-xem-thu-chi?thuchiId=${thuchiId}&isDaXem=${isDaDoc}`,
      {}
    ),
};

export default THUCHIHOPDONGApi;
